module.exports = __webpack_public_path__ + "img/pitch-events-banner-1600X700.1bf02647.png";